// src/pages/PurchaseRecord/index.js
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ArrowLeftOutlined, DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import PurchaseRecordFilters from "./components/PurchaseRecordFilters";
import PurchaseRecordTable from "./components/PurchaseRecordTable";
import ReportDom from "../../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { fetchPurchaseRecord } from "./PurchaseRecordThunks";
import { useNavigate } from "react-router-dom";
import { exportPurchaseRecordCsv } from "./components/exportPurchaseRecordCsv";

const { Title } = Typography;

const PurchaseRecord = () => {
  const dispatch = useDispatch();
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const purchaseRecordState = useSelector((state) => state.purchaseRecord) || {};
  const { filters = {}, list = [] } = purchaseRecordState;
  const authInfo  = useSelector((state) => state.auth?.auth_info);
  useEffect(() => {
    dispatch(fetchPurchaseRecord({}));
  }, [dispatch]);

  const navigate = useNavigate();

  
  const handleNavigateToReports = () => {
    navigate(-1);
  };
  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Purchase Report",
    removeAfterPrint: true,
  });
  const handleDownloadCsv = () => {
    exportPurchaseRecordCsv({
      list,
      filters,
      authInfo,
      title:    "Purchase Record",
      filename: "purchase_record",
    });
  };

  const hasData = list.length > 0;

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
           <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                type="text"
                icon={<ArrowLeftOutlined />}
                onClick={handleNavigateToReports}
                style={{ marginRight: 8 }}
              /> 
          <Title level={4} style={{ margin: 0 }}>Purchase Record</Title>
          </div>
        } extra={
            <Flex gap={8}>
              {hasData && (
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
              )}
              <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <PurchaseRecordFilters messageApi={message} />
        <Card className="shadow-md rounded-xl">
          <PurchaseRecordTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Purchase Report"
          mode="report-page"
          filters={filters}
          renderTable={() => <PurchaseRecordTable pagination={false} printMode={true} />}
        />
      </div>
    </div>
  );
};

export default PurchaseRecord;


